export type MeasurementCoords = {
    distance: number;
    depth: number;
};

const EMPTY_MEASUREMENT: MeasurementCoords = { distance: 0, depth: 0 };

/**
 * Displayed measurement is draft (saved edits) over firmware preset over the
 * first live reading. Telemetry is not followed after that first fallback.
 */
export function resolveDisplayedMeasurement(input: {
    draft: MeasurementCoords | null;
    saved: MeasurementCoords | null;
    liveFallback: MeasurementCoords | null;
}): MeasurementCoords {
    return input.draft ?? input.saved ?? input.liveFallback ?? EMPTY_MEASUREMENT;
}
